<template>
  <el-dialog :visible.sync="visible" width="min(640px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.financeSubjectId" class="title-actions">
        <el-button v-if="isAuth('finance:subject:update') || isAuth('finance:subject:save')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('finance:subject:delete') || isAuth('finance:subject:save')" type="danger" size="small" @click="deleteFromView">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" :disabled="readonly" label-width="100px">
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="科目编码" prop="subjectCode"><el-input v-model="form.subjectCode" /></el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="科目名称" prop="subjectName"><el-input v-model="form.subjectName" /></el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="上级科目">
        <el-select v-model="form.parentId" filterable clearable placeholder="点击选择上级科目" style="width:100%" @change="onParentChange">
          <el-option v-for="item in availableParents" :key="item.financeSubjectId" :label="item.subjectCode + ' ' + item.subjectName" :value="item.financeSubjectId" />
        </el-select>
      </el-form-item>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="科目类别" prop="subjectType">
            <el-select v-model="form.subjectType" :disabled="!!form.parentId" style="width:100%">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="余额方向" prop="balanceDirection">
            <el-select v-model="form.balanceDirection" style="width:100%">
              <el-option label="借" value="1" /><el-option label="贷" value="2" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="辅助核算">
        <el-checkbox v-model="form.auxCustomer" true-label="1" false-label="0">客户</el-checkbox>
        <el-checkbox v-model="form.auxSupplier" true-label="1" false-label="0">供应商</el-checkbox>
        <el-checkbox v-model="form.auxDepartment" true-label="1" false-label="0">部门</el-checkbox>
        <el-checkbox v-model="form.auxEmployee" true-label="1" false-label="0">职员</el-checkbox>
      </el-form-item>
      <el-form-item label="启用">
        <el-radio-group v-model="form.isenabled"><el-radio label="0">启用</el-radio><el-radio label="1">禁用</el-radio></el-radio-group>
      </el-form-item>
      <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="3" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import auth from './financeAuth'

function blank() {
  return {
    financeSubjectId: '', subjectCode: '', subjectName: '', parentId: '', subjectType: '1', balanceDirection: '1',
    auxCustomer: '0', auxSupplier: '0', auxDepartment: '0', auxEmployee: '0', isenabled: '0', remark: ''
  }
}

export default {
  name: 'SubjectAddOrUpdate',
  mixins: [auth],
  data() {
    return {
      visible: false, readonly: false, parents: [], form: blank(),
      typeOptions: [
        { value: '1', label: '资产' }, { value: '2', label: '负债' }, { value: '3', label: '权益' },
        { value: '4', label: '成本' }, { value: '5', label: '损益' }
      ],
      rules: {
        subjectCode: [{ required: true, message: '科目编码不能为空', trigger: 'blur' }],
        subjectName: [{ required: true, message: '科目名称不能为空', trigger: 'blur' }],
        subjectType: [{ required: true, message: '科目类别不能为空', trigger: 'change' }],
        balanceDirection: [{ required: true, message: '余额方向不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看科目'
      return this.form.financeSubjectId ? '修改科目' : '新增科目'
    },
    availableParents() {
      const blocked = new Set([this.form.financeSubjectId].filter(Boolean))
      let changed = true
      while (changed) {
        changed = false
        this.parents.forEach(item => {
          if (blocked.has(item.parentId) && !blocked.has(item.financeSubjectId)) {
            blocked.add(item.financeSubjectId)
            changed = true
          }
        })
      }
      return this.parents.filter(item => !blocked.has(item.financeSubjectId))
    }
  },
  methods: {
    loadParents() {
      request.get('/finance/subject/list').then(res => {
        const data = res && res.data
        this.parents = Array.isArray(data) ? data : ((data && data.list) || [])
      }).catch(() => { this.parents = [] })
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.loadParents()
      if (!id) {
        this.form = blank()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/finance/subject/info', { params: { id } }).then(res => {
        this.form = Object.assign(blank(), res.data || {})
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() { this.form = blank(); this.readonly = false },
    onParentChange(id) {
      const parent = this.parents.find(item => item.financeSubjectId === id)
      if (parent) this.form.subjectType = String(parent.subjectType)
    },
    deleteFromView() {
      this.$confirm('确定删除该科目?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/subject/delete', { id: this.form.financeSubjectId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/finance/subject/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
</style>
